<!-- 港区数据对比 -->
<template>
  <el-dialog
    width="80%"
    :visible.sync="visible"
    :before-close="cancel"
    :close-on-click-modal="false"
    :title="$t('SeaExport.DataComparison')"
  >
    <div class="harbour-data-compare">
      <div class="harbour-compare-tit">{{ $t('Message.Explain') }}<font class="none">{{ $t('Message.BlackIsTheInputData') }}</font><font class="blue">{{ $t('Message.BlueThePortAreaData') }}</font><span>{{ $t('Message.WhenTheBoxIsIdentifiedAsABox') }}</span>
        <p>{{ $t('Message.ClickEnteredDataPleaseOperation') }}</p>
      </div>
      <el-table
        ref="multipleTable"
        :cell-class-name="cellDisableFunc"
        :row-class-name="rowClassFunc"
        :data="tableList"
        height="300px"
        border
        row-key="uuid"
        :expand-row-keys="showExpand"
        @selection-change="handleSelect"
        @select="selectData"
        @select-all="selectAll"
      >
        <el-table-column
          type="selection"
          :selectable="selectable"
          width="55"
        />
        <el-table-column
          prop="type"
        >
          <template slot="header">
            <span>{{ $t('Message.ImportMode') }}</span>
            <i class="el-icon-question" style="color:#1F75D5" :title="$t('Message.ImportDescriptions')" />
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('SeaExport.ChargeSource')"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.isSystemData ? $t('Message.SystemEntry') : $t('Message.PortAreaData') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="containerIdentification"
          :label="$t('SeaExport.ContainerIdentification')"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.children ? $t('SeaExport.Box') : $t('SeaExport.Cargo') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="containerNo"
          :label="$t('Payment.containerNo')"
          width="120"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.containerNo }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="sealno"
          :label="$t('SeaExport.SealNo')"
          width="120"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.sealno }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="soNo"
          :label="$t('SeaExport.SoNo')"
          width="160"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.soNo }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="eqSize"
          :label="$t('SeaExport.ContainerSize')"
          width="60"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.eqSize + '\'' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="eqType"
          :label="$t('SeaExport.ContainerType')"
          width="60"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ mappingEqType(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="quantity"
          :label="$t('SeaExport.Quantity')"
          width="60"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.quantity }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="weight"
          :label="$t('SeaExport.Weight')"
          width="80"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.weight }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="cubage"
          :label="$t('SeaExport.Cubage')"
          width="80"
        >
          <template slot-scope="scope">
            <span :class="scope.row.isSystemData ? 'none' : 'blue'">{{ scope.row.cubage }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="sumbitHarbour">{{ $t('Message.UpdatedToPortAreaData') }}</el-button>
      <el-button @click="cancel">{{ $t('Message.Cancel2') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import lodash from 'lodash'
import StrUtils from '@/utils/StrUtils'
import { deepClone } from '@/utils'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'CompareHarbourDialog',
  props: {
    visible: { type: Boolean, default: () => false },
    job: { type: Object, default: () => {}, require: true },
    harbourSource: { type: Array, default: () => [], require: true }, // 港区数据
    dataSource: { type: Array, default: () => [], require: true },
    hqFlag: { type: Boolean, default: () => true },
    hcFlag: { type: Boolean, default: () => true },
    containerHeightFlag: { type: Boolean, default: () => true },
    hQHCFlag: { type: Boolean, default: () => false }
  },
  data() {
    return {
      tableList: [],
      selection: [],
      addNewGoods: [],
      showExpand: [],
      containerUsages: [],
      poItems: [],
      changeUsage: {}, // 需要变更的箱货号map
      newUsages: [], // 新增的箱货信息
      localHbrBourKeys: {}
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.hanldeCompareData()
      }
    },
    job(newVal, oldVal) {
      if (newVal) {
        this.loadPoItems()
      }
    }
  },
  methods: {
    async loadPoItems() {
      this.containerUsages = this.job.containerUsages
      this.dataSource.forEach(element => {
        element.form = 'S'
        element.weight = element.grossWeight
        delete element.grossWeight
      })
      this.poItems = lodash.cloneDeep(this.dataSource)
    },
    // 对数据按需求进行对比
    hanldeCompareData() {
      this.tableList = []
      this.localHbrBourKeys = {}
      this.harbourSource.map(e => {
        e.form = 'G'
        const isSystemVerificationHasNotConfirm = e.confirmed === 10 && PortDataCompareUtils.systemVerificationHasNotConfirm(e.containerNo, this.harbourSource)
        if ((e.confirmed === 0 || isSystemVerificationHasNotConfirm) && !e.type) {
          this.localHbrBourKeys[e.uuid] = true
        }
      })
      let backgroundColor = true
      const harbourList = []
      const usagesMap = {}
      this.containerUsages = this.containerUsages.sort((a, b) => {
        // 检查 a 的箱号是否为空
        if (!a.containerNo) return 1 // 如果 a 箱号为空，将其排在后面

        // 检查 b 的箱号是否为空
        if (!b.containerNo) return -1 // 如果 b 箱号为空，将其排在后面
        // 先按箱号排序
        if (a.containerNo < b.containerNo) return -1
        if (a.containerNo > b.containerNo) return 1
        // 再根据箱型排序
        return b.eqType.localeCompare(a.eqType)
      })
      const tempUsage = {}
      this.containerUsages.forEach((element, keys) => {
        delete element.type
        element.differentField = {}
        for (const eve of this.harbourSource) {
          const hasExists = tempUsage.hasOwnProperty(element.uuid)
          // 存在且一致
          const isSame = hasExists && (tempUsage[element.uuid] === eve.containerNo)
          // 箱号不为空，且箱号相同的数据，或当前业务的箱号为空，港区的箱号不为空且箱型箱量相同的
          if ((!StrUtils.isEmpty(eve.containerNo) && (eve.containerNo === element.containerNo)) ||
            (StrUtils.isEmpty(element.containerNo) && eve.containerNo && (!hasExists || isSame) && element.eqSize === eve.eqSize && (eve.eqType === element.eqType || eve.eqType.indexOf(element.eqType) > -1))) {
            const isSystemVerificationHasNotConfirm = eve.confirmed === 10 && PortDataCompareUtils.systemVerificationHasNotConfirm(eve.containerNo, this.harbourSource)
            if ((eve.confirmed === 0 || isSystemVerificationHasNotConfirm) && !eve.type) {
              tempUsage[element.uuid] = eve.containerNo
              backgroundColor = !backgroundColor
              eve.eqType = eve.eqType instanceof Array ? (eve.eqType.length === 1 ? eve.eqType[0] : element.eqType) : eve.eqType
              this.addUpdateNode(element, eve, usagesMap, backgroundColor)
            }
            harbourList.push(eve.uuid)
          }
        }
      })
      // 箱号不一致 && 没有匹配的箱型箱种 && 港区数据 >= 当前数据
      this.newUsages = {}
      this.harbourSource.forEach((eve, index) => {
        if (eve.confirmed === 0 && !eve.type) {
          eve.eqType = eve.eqType instanceof Array ? eve.eqType[0] : eve.eqType
          if (!usagesMap.hasOwnProperty(eve.containerNo)) {
            backgroundColor = !backgroundColor
            const obj = this.addFatherNode(eve, '新增', false, backgroundColor)
            obj.form = 'G'
            this.tableList.push(obj)
            this.showExpand.push(obj.uuid)
            usagesMap[eve.containerNo] = obj
          }
          eve.jobUuid = this.job.uuid
          PortDataCompareUtils.addNewContainerUsages(eve, this.newUsages)
          const temp = usagesMap[eve.containerNo]
          eve.type = '新增'
          eve.backgroundColor = backgroundColor
          temp.children.push(eve)
        }
      })
      // 保持
      this.containerUsages.forEach((element, keys) => {
        if (!element.type) {
          backgroundColor = !backgroundColor
          const obj = this.addFatherNode(element, '保持', true, backgroundColor)
          this.showExpand.push(obj.uuid)
          this.tableList.push(obj)
        }
      })
      this.$nextTick(() => {
        this.tableList.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
          if (row.isSystemData) {
            return
          }
          let quantity = 0
          let weight = 0.000
          let cubage = 0.000
          for (const data of row.children) {
            quantity += data.quantity ? parseInt(data.quantity) : 0
            weight += data.weight ? parseFloat(data.weight) : 0
            cubage += data.cubage ? parseFloat(data.cubage) : 0
          }
          row.quantity = NumberUtils.formatNumber(quantity, 0)
          row.weight = NumberUtils.formatNumber(weight, 3)
          row.cubage = NumberUtils.formatNumber(cubage, 3)
        })
      })
    },
    // 设置表格是否可以勾选
    selectable(row, index) {
      if ((row.children || row.type === '保存') && !row.isSystemData) {
        return true
      } else {
        return false
      }
    },
    calculation(source, target, data) {
      target.quantity += data.quantity ? parseInt(data.quantity) : 0
      target.weight += data.weight ? parseFloat(data.weight) : 0
      target.cubage += data.cubage ? parseFloat(data.cubage) : 0
      if (source) {
        source.quantity = target.quantity
        source.weight = target.weight
        source.cubage = target.cubage
      }
    },
    /**
     * 添加修改节点
     * @param systemData
     * @param harbourData
     * @param usagesMap
     */
    addUpdateNode(systemData, harbourData, usagesMap, backgroundColor) {
      systemData.type = '修改'
      if (!usagesMap.hasOwnProperty(harbourData.containerNo)) {
        const oldObj = this.addFatherNode(systemData, '修改', true, backgroundColor)
        oldObj.uuid = systemData.uuid
        this.tableList.push(oldObj)
        this.showExpand.push(oldObj.uuid)
        const obj = this.addFatherNode(harbourData, '修改', false, backgroundColor)
        obj.sourceUuid = systemData.uuid
        if (systemData.containerNo !== harbourData.containerNo) {
          obj.containerNo = harbourData.containerNo
          obj.differentField['containerNo'] = true
        }
        obj.sealno = systemData.sealNo
        if (systemData.sealNo !== harbourData.sealno) {
          obj.sealno = harbourData.sealno
          obj.differentField['sealno'] = true
        }
        PortDataCompareUtils.syncPortDate(harbourData, obj)
        obj.confirmed = 11
        this.tableList.push(obj)
        this.showExpand.push(obj.uuid)
        usagesMap[harbourData.containerNo] = obj
      }
      const temp = usagesMap[harbourData.containerNo]
      const poItem = deepClone(harbourData)
      poItem.uuid = ''
      poItem.grossWeight = harbourData.weight
      systemData.tempPoItems.push(poItem)
      harbourData.type = '修改'
      harbourData.containerUsageKey = systemData.uuid
      harbourData.grossWeight = harbourData.weight
      temp.children.push(harbourData)
    },
    addFatherNode(data, type, isSystemData = false, backgroundColor) {
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      const sealNo = data.hasOwnProperty('sealno') ? data.sealno : data.sealNo
      if (data.poItems && data.poItems.length > 0) {
        data.poItems.forEach(item => {
          item.weight = item.grossWeight
          item.type = type
          if (type === '保持') {
            delete item.form
          }
          item.isSystemData = isSystemData
          item.sealno = sealNo
          item.backgroundColor = backgroundColor

          quantity += item.quantity ? parseInt(item.quantity) : 0
          weight += item.weight ? parseFloat(item.weight) : 0
          cubage += item.cubage ? parseFloat(item.cubage) : 0
        })
      } else {
        quantity = data.quantity
        weight = data.weight
        cubage = data.cubage
      }
      const obj = {
        uuid: data.uuid + '_index',
        type: type,
        containerNo: data.containerNo,
        sealno: sealNo,
        eqSize: data.eqSize,
        eqType: data.eqType,
        quantity: NumberUtils.formatNumber(quantity, 0),
        weight: NumberUtils.formatNumber(weight, 3),
        cubage: NumberUtils.formatNumber(cubage, 3),
        containerUsageKey: data.uuid,
        isSystemData: isSystemData,
        backgroundColor: backgroundColor,
        sourceUuid: data.uuid,
        children: data.poItems ? deepClone(data.poItems) : []
      }
      PortDataCompareUtils.syncPortDate(data, obj)
      data.tempPoItems = []
      data.tempPoItems = data.tempPoItems.concat(data.poItems)
      obj.differentField = {}
      return obj
    },
    // 取消变更
    cancel() {
      if (this.harbourSource && this.harbourSource.length > 0) {
        this.harbourSource.forEach((eve, index) => {
          if (this.localHbrBourKeys[eve.uuid]) {
            delete eve.type
            delete eve.form
            eve.confirmed = 0
          }
        })
      }
      this.clearDialog()
    },
    // 弹窗关闭
    clearDialog() {
      this.tableList = []
      this.localHbrBourKeys = {}
      this.$emit('update:visible', false)
    },
    selectData(selection, row) {
      if (row.type === '修改') {
        const selectRow = this.isSelect(selection, row.uuid)
        for (const data of this.tableList) {
          if (data.uuid !== row.uuid && data.sourceUuid === row.sourceUuid) {
            const otherSelect = this.isSelect(selection, data.uuid)
            if (selectRow !== otherSelect) {
              // 非系统数据，且重新选中时，需要将数据添加进选中
              if (!data.isSystemData) {
                this.changeSelect(data, !otherSelect)
              }
              this.$refs.multipleTable.toggleRowSelection(data)
            }
          }
        }
      }
    },
    changeSelect(data, isSelect) {
      const removeKey = {}
      data.children.map(item => {
        if (item.form === 'G') {
          if (isSelect) {
            this.selectMap[item.type === '新增' ? item.containerNo : item.containerUsageKey] = data
            this.changeUsage[item.type === '新增' ? item.containerNo : item.containerUsageKey] = item.containerNo
            const confirmed = PortDataCompareUtils.getConfirmed(item.type)
            this.selection.push({
              uuid: item.uuid,
              confirmed: confirmed,
              jobUuid: this.job.jobUuid
            })
          } else {
            removeKey[item.uuid] = true
          }
        }
      })
      this.selection.forEach(function(item, index, arr) {
        if (removeKey.hasOwnProperty(item.uuid)) {
          arr.splice(index, 1)
        }
      })
    },
    isSelect(selection, uuid) {
      if (selection && selection.length > 0) {
        for (const data of selection) {
          if (data.uuid === uuid) {
            return true
          }
        }
      }
      return false
    },
    // 处理表格选中
    handleSelect(selection) {
      const result = []
      this.changeUsage = {}
      this.selectMap = {}
      selection.forEach(eve => {
        if (eve.children) {
          eve.children.map(item => {
            if (item.form === 'G') {
              this.selectMap[item.type === '新增' ? item.containerNo : item.containerUsageKey] = eve
              this.changeUsage[item.type === '新增' ? item.containerNo : item.containerUsageKey] = item.containerNo
              const confirmed = PortDataCompareUtils.getConfirmed(item.type)
              result.push({
                uuid: item.uuid,
                confirmed: confirmed,
                jobUuid: this.job.jobUuid
              })
            }
          })
        }
      })
      this.selection = result
    },
    // 更新港区数据状态
    sumbitHarbour() {
      if (this.selection.length > 0) {
        // 修改箱型箱种的数据
        // 修改数据的对比处理
        this.containerUsages.forEach(item => {
          if (this.changeUsage.hasOwnProperty(item.uuid)) {
            // 重新计算件毛体
            let quantity = 0
            let weight = 0.000
            let cubage = 0.000
            for (const data of item.tempPoItems) {
              quantity += data.quantity ? parseInt(data.quantity) : 0
              weight += data.weight ? parseFloat(data.weight) : 0
              cubage += data.cubage ? parseFloat(data.cubage) : 0
            }
            item.quantity = NumberUtils.formatNumber(quantity, 0)
            item.weight = NumberUtils.formatNumber(weight, 3)
            item.cubage = NumberUtils.formatNumber(cubage, 3)
            item.containerNo = this.changeUsage[item.uuid]
            item.poItems = item.tempPoItems
            const map = this.selectMap[item.uuid]
            item.sealNo = map.sealno
            item.confirmed = map.confirmed
            // 更新箱型箱种
            if (item.eqSize !== map.eqSize || item.eqType !== map.eqType) {
              PortDataCompareUtils.changeSeaEQ(this.job.seaEQ, item.eqSize, item.eqType, map.eqSize, map.eqType, this.job)
              item.eqSize = map.eqSize
              item.eqType = map.eqType
            }
            PortDataCompareUtils.syncPortDate(map, item)
            item.container.isDirty = true
            PortDataCompareUtils.syncPortDate(map, item.container)
          }
        })
        // 处理新增的数据对比
        for (const containerNo in this.changeUsage) {
          if (this.newUsages.hasOwnProperty(containerNo)) {
            this.containerUsages.push(this.newUsages[containerNo])
          }
        }
        // 重置其他未选中的港区数据
        for (const data of this.selection) {
          this.localHbrBourKeys[data.uuid] = false
        }
        this.cancel()
        this.$emit('addContainer', this.poItems, this.selection)
      } else {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
      }
    },
    rowClassFunc({ row, rowIndex }) {
      return row.backgroundColor ? 'warning-row' : ''
    },
    cellDisableFunc({ row, rowIndex }) {
      return !row.children ? 'cell-display' : ''
    },
    selectAll(selection) {
      console.info('selection', selection)
    },
    mappingEqType(scopeRow) {
      if (this.HQHCFlag) {
        return scopeRow.eqType
      }
      if (!scopeRow.isSystemData) {
        if (this.containerHeightFlag) {
          return scopeRow.eqType
        }
        const reflectEqType = scopeRow.eqType
        if (!this.hqFlag || !this.hcFlag) {
          if (this.hqFlag) {
            return reflectEqType.replace('HC', 'HQ')
          }
          return reflectEqType.replace('HQ', 'HC')
        }
      }
      return scopeRow.eqType
    }
  }
}
</script>

<style lang="scss" scoped>
.harbour-data-compare{
  .gray{
    color: #cccccc;
  }
  .blue{
    color: blue;
  }
  .none{
    color: #000;
  }
  .harbour-compare-tit{
    margin: 3px 0 8px;
    color: #999;
    font-size: 13px;
    font{
      font-size: 13px;
    }
    p{
      line-height: 26px;
      margin: 0;
      text-indent: 35px;
      font-size: 13px;
    }
  }
  /deep/ .el-table .warning-row {
    background-color: lightgrey;
  }
  /deep/ .el-table .cell-display .el-checkbox__input {
    display: none;
  }

  /deep/ .el-table .success-row {
    background: #ffffff;
  }
  /deep/ .el-table__header-wrapper th{
    color: #000;
  }
}
</style>
